import {
  BorderStyle,
  Box,
  Button,
  ButtonColorVariant,
  ButtonVariant,
  Color,
  Theme,
  withCitrusTheme,
} from '@gousto-internal/citrus-react';

type Props = {
  accessibleLabel: string;
  onAdd: () => void;
  onRemove: () => void;
  mode: 'ADD' | 'REMOVE' | 'DISABLED';
};

function buttonStyles(theme: Theme) {
  return {
    borderRadius: 8,
    ...theme.border.width(2),
    ...theme.border.style(BorderStyle.Solid),
    ...theme.border.color(Color.White),
  };
}

const StyledButton = withCitrusTheme(Button, buttonStyles);

export function SelectRecipeButton(props: Props) {
  const removing = props.mode === 'REMOVE';
  const disabled = props.mode === 'DISABLED';

  return (
    <StyledButton
      variant={ButtonVariant.Icon}
      colorVariant={removing ? ButtonColorVariant.Secondary : ButtonColorVariant.Primary}
      icon={removing ? 'remove' : 'add'}
      onClick={removing ? props.onRemove : props.onAdd}
      data-testid="select-recipe-button"
      disabled={disabled}
    >
      {props.accessibleLabel}
    </StyledButton>
  );
}

/**
 * Allows us to space items in different containers
 * around SelectRecipeButton
 */
export const HiddenSelectRecipeButton = withCitrusTheme(Box, (theme) => ({
  ...buttonStyles(theme),
  width: '48px', // Icon button native width
  visibility: 'hidden',
}));
